export default "__VITE_ASSET__584f62d5__"